// React
import React from 'react';

// Prop types
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';

// Component
import SerivceName from './SerivceName';
import ToDoView from './ToDoView';
import ReciprocalContentDialog from './ReciprocalContentDialog';

// Actions
import * as roomActions from '../../../actions/roomActions';

// Mui styles
import { withStyles } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';

const styles = () =>
	({
		root : {
			height          : 'calc(100% - 100px)',
			aspectRatio     : 1.777,
			maxWidth        : '98vw',
			minWidth        : 800,
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			overflow        : 'auto',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '1%'
		}
	});

const ToDo = ({
	classes,
	room,
	openReciprocalContentDialog,
	setMemo
}) =>
{
	const onMemoSelected = (item) =>
	{
		setMemo(item);
		openReciprocalContentDialog();
	};

	return (
		<Box className={classes.root}>
			<SerivceName />
			<ToDoView onSelect={onMemoSelected}/>

			{room.reciprocalContentDialogOpen &&
				<ReciprocalContentDialog />
			}
		</Box>
	);
};

ToDo.propTypes =
{
	classes                     : PropTypes.object.isRequired,
	room                        : PropTypes.object.isRequired,
	openReciprocalContentDialog : PropTypes.func.isRequired,
	setMemo                     : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room : state.room
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		openReciprocalContentDialog : () =>
		{
			dispatch(roomActions.setReciprocalContentDialogOpen(true));
		},
		setMemo : (memo) =>
		{
			dispatch(roomActions.setMemo(memo));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.reciprocalContentDialogOpen === next.room.reciprocalContentDialogOpen
			);
		}
	}
)(withStyles(styles)(ToDo)));
